import React from 'react';
import PropTypes from 'prop-types';

function Center({children, verticalOnly = false, horizontalOnly = false}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: horizontalOnly ? null : 'center',
        justifyContent: verticalOnly ? null : 'center',
        height: '100%',
        width: '100%',
      }}
    >
      {children}
    </div>
  );
}

Center.propTypes = {
  children: PropTypes.node,
  verticalOnly: PropTypes.bool,
  horizontalOnly: PropTypes.bool,
};

export default Center;
